import Tools from '@/components/tools/Tools'
import AccountRepository from '@/shared/http/repositories/access/account'
import AccountPciItemModelRepository from '@/shared/http/repositories/pci/pcimodeloitemconta'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import itemMixim from '@/views/private/operational/pci/mixins/itemMixim'
import ItemTreeView from '../../../operational/pci/components/treeview/ItemTreeView.vue'

export default {
  name: 'Items',
  components: {
    ItemTreeView
  },
  mixins: [itemMixim, CompanyMixin],
  data () {
    return {
      users: [],
      selectedUser: null,
      selectedUserName: '',
      selectedUsersCopy: [],
      showItems: false,
      showCopy: false,
      items: []
    }
  },
  beforeMount () {
    Tools.MinimizedSidebar()
    loading.push()

    // Get accounts
    AccountRepository.GetAll()
      .then(response => {
        // Verifies response status
        if (response.data.code > 0) {
          // Stores only relevant data
          this.users = response.data.data.filter(ac => ac.grupo.nome !== 'ADMINISTRADORES').map(account => ({
            value: account.id,
            text: account.nome + ' (' + account.username + ')'
          }))
        }
      })
      .catch(error => {
        // Set toast
        toast.error(this.$lang.Common.Alerts.Error)
        console.log(error)
      })
      .finally(() => loading.close())
  },
  methods: {
    // Render tree view to user
    onSelectUser () {
      if (!this.selectedUser) {
        this.items = []
        this.showItems = false
        this.selectedUserName = ''
        return
      }

      loading.push()
      // Get user items
      AccountPciItemModelRepository.GetItems(this.company.id, this.selectedUser)
        .then(response => {
          // Verifies response status
          if (response.data.code > 0) {
            // Format items to correct hierarchy

            this.selectedUserName = this.users.find(x => x.value === this.selectedUser).text

            const list = response.data.data.map(item => {
              return {
                id: item.pciModeloItem.id,
                code: item.pciModeloItem.codigo,
                name: item.pciModeloItem.descricao,
                parentId: item.pciModeloItem.itemPaiID,
                permission: item.permissao
              }
            })

            // Get PCI itens hierarchy
            this.items = this.getHierarchy(list)
            this.showItems = true
          }
        })
        .catch(error => {
          toast.error(this.$lang.Common.Alerts.Error)
          console.log(error)
        })
        .finally(() => {
          loading.close()
        })
    },
    onTogglePermission (item, permissionOn, permissionOff) {
      item.permission = item.permission ? (item.permission < permissionOn ? permissionOn : permissionOff) : permissionOn

      if (item.children) {
        const _updateChild = (_item) => {
          _item.permission = item.permission
          if (_item.children) {
            _item.children.forEach(_it => _updateChild(_it))
          }
        }

        item.children.forEach(_it => _updateChild(_it))
      }

      if (item.parentId) {
        const _updateFather = (_list, _fatherID) => {
          _list.forEach(_item => {
            if (_item.id === _fatherID) {
              const _itFiltered = _item.children.filter(_child => _child.permission > 0)
              let permission = _itFiltered.length ? 15 : 0
              _itFiltered.forEach(_child => {
                permission = Math.min(_child.permission, permission)
              })
              this.$set(_item, 'permission', permission)
              if (_item.parentId) {
                _updateFather(this.items, _item.parentId)
              }
            } else if (_item.children && _item.children.length) {
              _updateFather(_item.children, _fatherID)
            }
          })
        }

        _updateFather(this.items, item.parentId)
      }
    },
    saveUserAccess () {
      this.onSaveOrCopy(false)
    },
    onShowCopy () {
      this.selectedUsersCopy = []
      this.showCopy = true
    },
    onSaveOrCopy (copy = false) {
      loading.push()

      // Store checked items
      let noTreeItems = []

      // loading.push()

      const unmountTree = root => {
        root.map(item => {
          let obj = {
            pciModeloItem: {
              id: item.id,
              pciModeloItemIDPai: item.parentId ? item.parentId : null
            },
            permissao: item.permission,
            a: item
          }

          if (copy) {
            obj.contas = this.selectedUsersCopy
          }

          noTreeItems.push(obj)

          if (item.children) {
            unmountTree(item.children)
          }
        })
      }

      // Get selected PCI Itens
      unmountTree(this.items)

      // Filter items
      let selected = noTreeItems.filter(i => i.permissao > 0)

      AccountPciItemModelRepository.SaveItemsPermissions(this.company.id, this.selectedUser, selected)
        .then(response => {
          toast.success(this.$lang.Common.Alerts.Success)
          loading.close()
        })
        .catch(() => {
          toast.error(this.$lang.Common.CouldNotSave)
          loading.close()
        })
    },
    onCopy () {
      if (this.selectedUsersCopy && this.selectedUsersCopy.length) {
        this.onSaveOrCopy(true)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/pci/items/items.js